import { fabric } from 'fabric';

const Circle = fabric.util.createClass(fabric.Ellipse, {
  type: 'circle',

  initialize(element, options) {
    options || (options = {});
    this.callSuper('initialize', element, options);

    // Set default options
    this.set({
      rotateAngle: 0,
      hasRotatingPoint: false,
      radius: 100,
      opacity: 0.3,
    });
  },

  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      customProps: this.customProps,
      rotateAngle: this.angle,
    });
  },
});

export default Circle;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Items/Circle.js